<main id="main-content" class="main-content">
    <div class="red-warning" *ngIf="errorList.length > 0">
        <mat-icon class="red-warn-icon">warning</mat-icon>
        <div class="red-warn-text">
            <span class="red-title">Incomplete section</span>
            <span class="red-text">
                The following fields are missing details. Please complete them before proceeding to the next section:
                <ul>
                    @for (error of errorList; track error) {
                    <li>{{error | titlecase}}</li>
                    }
                </ul>
            </span>
        </div>
    </div>
    <h2 class="form-header">3. Additional Information</h2>

    <mat-card [formGroup]="form">
        <div class="title">3a. Treatment Success, Failures and Recommendations</div>
        <div class="bar">&nbsp;</div>
        <div class="text-div">
            <b>Provide additional information on treatment success and/or failures.</b>
            <br>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().success_failure || '--')"></div>
        <div class="text-div">
            <b>Provide any recommendations for future treatments. </b>
            <br>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().recommendations || '--')"></div>
        <div class="text-div">
            <b>Provide additional information on plans for project completion.</b>
            <br>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().plans || '--')"></div>


    </mat-card>
    <mat-card>
        <div class="title">3b. Additional Reports</div>
        <div class="bar">&nbsp;</div>
        <div class="whole-line">
            <div class="file-list-header">File name</div>
            <div class="file-list-header header-right">Box Link</div>
        </div>@if(this.report().additional_reports.length > 1 || this.report().additional_reports[0].name != '' ||
        this.report().additional_reports[0].link != '') {
        <div class="bar-header">&nbsp;</div>
        }
        @for(additionalReport of this.report().additional_reports; track additionalReport; let j = $index) {
        <div class="whole-line" *ngIf="additionalReport.link !=''">
            <div class="file-list">{{additionalReport.name}}</div>
            <div class="file-list link-right"><a class="box-link" [href]="additionalReport.link"
                    target="_blank"><fa-icon [icon]="faArrowUpRightFromSquare" class="fa-regular fa-green"
                        aria-label="close"></fa-icon>Open in Box</a></div>
        </div>
        <div class="bar">&nbsp;</div>
        }
        @if(this.report().additional_reports.length == 1 && this.report().additional_reports[0].name == '' &&
        this.report().additional_reports[0].link == '') {
        <div class="no-data">
            <div class="no-data-icon">
                <img class="no-data-icon3" src="assets/img/empty-state-page.svg" alt="No Reports">
            </div>
            <div class="no-data-title">No Reports Were Added</div>
        </div>
        }
    </mat-card>
</main>